'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = require('./styled/');

var _styled2 = _interopRequireDefault(_styled);

var _vars = require('./vars');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _NavLink(props) {
  var children = props.children,
      to = props.to,
      nativeLink = props.nativeLink,
      propsRest = _objectWithoutProperties(props, ['children', 'to', 'nativeLink']);

  return nativeLink ? _react2.default.createElement(_styled2.default.NavLinkNative, _extends({
    href: to
  }, propsRest), children) : _react2.default.createElement(_styled2.default.NavLink, _extends({
    to: to,
    activeClassName: 'active'
  }, propsRest), children);
}

function _Item(props) {
  var children = props.children,
      propsRest = _objectWithoutProperties(props, ['children']);

  return _react2.default.createElement(_styled2.default.Item, propsRest, children);
}

function _SubMenu(props) {
  var children = props.children,
      title = props.title,
      place = props.place,
      propsRest = _objectWithoutProperties(props, ['children', 'title', 'place']);

  return _react2.default.createElement(_styled2.default.SubMenu, _extends({
    place: place
  }, propsRest), _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_styled2.default.SubMenuTitle, {
    place: place
  }, title), _react2.default.createElement(_styled2.default.SubMenuListWrapper, {
    place: place
  }, _react2.default.createElement(_styled2.default.SubMenuList, {
    place: place
  }, children))));
}

function Menu(props) {
  var place = props.place;
  return {
    Wrapper: function Wrapper(props) {
      return _react2.default.createElement(_styled2.default.Wrapper, _extends({
        place: place
      }, props));
    },
    List: function List(props) {
      return _react2.default.createElement(_styled2.default.List, _extends({
        place: place
      }, props));
    },
    Item: function Item(props) {
      return _react2.default.createElement(_Item, _extends({
        place: place
      }, props));
    },
    NavLink: function NavLink(props) {
      return _react2.default.createElement(_NavLink, _extends({
        place: place
      }, props));
    },
    SubMenu: function SubMenu(props) {
      return _react2.default.createElement(_SubMenu, _extends({
        place: place
      }, props));
    }
  };
}

Menu.propTypes = {
  place: _propTypes2.default.oneOf([_vars.place.Header, _vars.place.Sidebar])
};
Menu.defaultProps = {
  place: _vars.place.Header
};

exports.default = function (props) {
  return new Menu(props);
};